import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { CustomerPurchaseOrder } from "@/models/customer-purchase-order.model"
import { ModelFactory } from "@/factories/model-factory"
import ModelManager from "@/services/model-manager"

export const useCustomerPurchaseOrderStore = defineStore("customerPurchaseOrderStore", () => {
  const customerPurchaseOrders: Ref<CustomerPurchaseOrder[]> = ref([])
  const manualDraft: Ref<CustomerPurchaseOrder | null> = ref(null)

  function openManualDraft(): CustomerPurchaseOrder {
    if (!manualDraft.value || manualDraft.value.isSaved) {
      manualDraft.value = ModelFactory.createModel(CustomerPurchaseOrder)
      manualDraft.value.approvalMethod = "email"
    }
    const draft = manualDraft.value
    if (!customerPurchaseOrders.value.some((order) => order.id === draft.id)) {
      customerPurchaseOrders.value.unshift(draft)
    }
    return draft
  }

  function discardEmptyDraft(order: CustomerPurchaseOrder) {
    if (order.isSaved || order.hasApprovalContent() || manualDraft.value?.id !== order.id) return
    customerPurchaseOrders.value = customerPurchaseOrders.value.filter(
      (item) => item.id !== order.id
    )
    ModelManager.getInstance().evict(order.id!)
    manualDraft.value = null
  }

  return {
    customerPurchaseOrders,
    manualDraft,
    openManualDraft,
    discardEmptyDraft
  }
})
